import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-cellsignallow",
  "use": "icon-th-cellsignallow-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-cellsignallow\">\n<path d=\"M11 19V25C11 25.2652 10.8946 25.5196 10.7071 25.7071C10.5196 25.8946 10.2652 26 10 26C9.73478 26 9.48043 25.8946 9.29289 25.7071C9.10536 25.5196 9 25.2652 9 25V19C9 18.7348 9.10536 18.4804 9.29289 18.2929C9.48043 18.1054 9.73478 18 10 18C10.2652 18 10.5196 18.1054 10.7071 18.2929C10.8946 18.4804 11 18.7348 11 19ZM5 23C4.73478 23 4.48043 23.1054 4.29289 23.2929C4.10536 23.4804 4 23.7348 4 24V25C4 25.2652 4.10536 25.5196 4.29289 25.7071C4.48043 25.8946 4.73478 26 5 26C5.26522 26 5.51957 25.8946 5.70711 25.7071C5.89464 25.5196 6 25.2652 6 25V24C6 23.7348 5.89464 23.4804 5.70711 23.2929C5.51957 23.1054 5.26522 23 5 23Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-cellsignallow.svg
// module id = Hsd9
// module chunks = 84